export const forceStaging = url => {
    try {
        const parsed = new URL(url);

        if (parsed.hostname.includes('.uat.')) {
            parsed.hostname = parsed.hostname.replace('.uat.', '.');
        }

        return parsed.toString().replace(/\/$/, '');
    } catch {
        return url;
    }
};
